import {IObservation} from '../message-models/observation.interface';
import {IDateTimeWithZone} from '../common/date-time-with-zone.interface';
import {DateTimeWithZone} from '../common/date-time-with-zone.class';

export class Observation implements IObservation{
  id: string;
  summaryInfo: string;
  notesAsHtml: string;
  observedBy: string;
  observedOn: DateTimeWithZone;
  followUpOn: DateTimeWithZone;
  observationType: ObservationType;
  constructor(iObservation?: IObservation ) {
    this.id = iObservation?.id || '00000000-0000-0000-0000-000000000000';
    this.summaryInfo = iObservation?.summaryInfo || '';
    this.notesAsHtml = iObservation?.notesAsHtml || '';
    this.observedBy = iObservation?.observedBy || '';
    this.observedOn = new DateTimeWithZone(iObservation?.observedOn) || new DateTimeWithZone({} as IDateTimeWithZone);
    this.followUpOn = new DateTimeWithZone(iObservation?.followUpOn) || new DateTimeWithZone({} as IDateTimeWithZone);
    if(iObservation.observationType !=null){
      this.observationType = iObservation.observationType;
    }else{
      this.observationType = null;
    }

  }
  get isValid() : boolean {
    return !!this.summaryInfo && !!this.observedBy && !!this.observedOn?.dateTime
  }
}

export enum ObservationType {
  Company,
  Operative,
  TrainingRecord,
  CompanyDocument,
  OperativeDocument,
  TrainingRecordDocument
}
export enum ObservationTypeString {
  'Company',
  'Operative',
  'Training Record',
  'Enterprise Document',
  'Operative Document',
  'Training Record Document'
}
